'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.draggableContainers = twentyninetimes.draggableContainers || function () {

	function init() {
		draggableContainer();
	}

	function draggableContainer() {
        // Create draggable containers function
        const draggable_containers = document.querySelectorAll('.js-draggable-container');

        if ( draggable_containers ) {
            let isDown = false;
            let startX;
            let scrollLeft;

            draggable_containers.forEach(container => {
                container.addEventListener('mousedown', (e) => {
                  isDown = true;
                  //container.classList.add('active');
                  startX = e.pageX - container.offsetLeft;
                  scrollLeft = container.scrollLeft;
                });

                container.addEventListener('mouseleave', () => {
                  isDown = false;
                  //container.classList.remove('active');
                });

                container.addEventListener('mouseup', () => {
                  isDown = false;
                  //container.classList.remove('active');
                });

                container.addEventListener('mousemove', (e) => {
                  if(!isDown) return;
                  e.preventDefault();
                  const x = e.pageX - container.offsetLeft;
                  const walk = (x - startX) * 1; //scroll-fast
                  container.scrollLeft = scrollLeft - walk;
                  console.log(walk);
                });
            });
        }
    }

	return {
		init : init
	};

}();